export default function _geoform() {
    // console.log('geoform');
    // Check if the module exists before doing anything
    const GeolocationFormComponentExists = !!document.querySelector('.geoform');
    const ServicesMapComponentExists =
        !!document.querySelector('.services-map');

    // If the module exists, do whatever we need to
    if (GeolocationFormComponentExists && !ServicesMapComponentExists) {
        // JS media query to move the geoform component placement on the page
        document.addEventListener('DOMContentLoaded', function () {
            const geoformPlaceholderEl = document.querySelector(
                '.geoform-placeholder--desktop'
            );
            const geoformEl = document.querySelector('.geoform');
            if (!geoformPlaceholderEl) return; // check if geoform placeholder div is on the page

            const mediaQuery = window.matchMedia('(min-width: 992px)');

            if (mediaQuery.matches) {
                geoformEl.style.display = 'none';
                geoformPlaceholderEl.appendChild(geoformEl);
                geoformEl.style.display = 'block';
            }
        });

        // User geolocation
        let geoformLat;
        let geoformLng;
        const userGeoBtn = document.querySelector('.geoform-user-loc__btn');
        const geoformSubmitBtn = document.querySelector('.geoform-submit__btn');

        const getUserLocation = function () {
            const options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            };

            document.querySelector('.geoform__spinner').style.display = 'block';

            function success(pos) {
                const crd = pos.coords;

                console.log('Your current position is:');
                console.log(`Latitude : ${crd.latitude}`);
                console.log(`Longitude: ${crd.longitude}`);

                geoformLat = crd.latitude;
                geoformLng = crd.longitude;

                geoformSubmitBtn.disabled = false;

                // Add address in location field
                fetch(
                    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${geoformLat},${geoformLng}&key=AIzaSyBOYJ_2mnQFQgTe5RfgvPD5ltiVCIXvvIQ`
                )
                    .then((response) => {
                        return response.json();
                    })
                    .then((data) => {
                        const address = data.results[0].formatted_address;
                        document.getElementById(
                            'geoform-autocomp__input'
                        ).value = address;
                    });

                document.querySelector('.lds-dual-ring').style.display = 'none';
            }

            function error(err) {
                console.warn(`ERROR(${err.code}): ${err.message}`);
            }

            navigator.geolocation.getCurrentPosition(success, error, options);
        };

        userGeoBtn.addEventListener('click', getUserLocation);

        geoformSubmitBtn.addEventListener('click', function () {
            window.open(
                `/services-near-me?coords=&lat=${geoformLat}&lng=${geoformLng}`,
                '_self'
            );
        });
    }
}
_geoform();
